window.$ = window.jQuery = require("../node_modules/jquery/dist/jquery.js");

require("imports-loader?$=jquery!../node_modules/bootstrap/dist/js/bootstrap.js");
require("imports-loader?$=jquery!../node_modules/owl.carousel/dist/owl.carousel.js");
require("imports-loader?$=jquery!../node_modules/jquery-mousewheel/jquery.mousewheel.js");

require("imports-loader?$=jquery!./js/jquery.mCustomScrollbar.js");
